import difference from 'lodash/difference'

const urlRegex = /\//g
const choiceUrlRegex = /^(\/)*(?:assets\/media\/images\/)[a-zA-Z-_.]+(?:.jpg|png)$/g
const targetQuestionStructure = ['choices', 'escapeText', 'id', 'label', 'url']
const targetChoiceStructure = ['choice', 'id', 'imageUrl']

export const initialState = {
  questions: [],
  result: {},
  filters: [],
  orderings: {}
}

const choiceIsValid = (choice) => !difference(targetChoiceStructure, Object.keys(choice)).length &&
  choiceUrlRegex.test(choice.imageUrl)

const validateChoices = (choices) => choices.some(choiceIsValid)

const questionIsValid = (question) => {
  if (difference(targetQuestionStructure, Object.keys(question)).length) {
    return false
  }
  const { id, choices, escapeText, label, url } = question
  if (typeof id !== 'number' ||
    typeof escapeText !== 'string' ||
    typeof label !== 'string' ||
    !Array.isArray(choices) ||
    urlRegex.test(url)) {
    return false
  }
  return validateChoices(choices)
}

const validateQuestions = (questions) => questions.some(questionIsValid)

export default (persistedState) => {
  if (!persistedState || difference(Object.keys(persistedState), Object.keys(initialState)).length) {
    return initialState
  }
  const { questions } = persistedState
  if (!(questions && Array.isArray(questions))) {
    return initialState
  }
  return validateQuestions(questions)
    ? persistedState
    : initialState
}
